export const SKILL_INVOCATION_LABEL = "When to use this skill";
export const SKILL_INSTRUCTIONS_LABEL = "Instructions";
